<template>
  <div style="display: flex;flex-direction: column">
    <cargo-advance-select
      :disabled="true"
      :select-type="TYPE_NAMES.basic_data_Seaport"
      :default-value="cargoDoc.destinationPortCode"
      tag-name="englishName"
      v-bind="$attrs"
    />
    <el-input v-model="cargoDoc.destinationPort" style="margin-top: 5px;" @change="onChange('destinationPort')" />
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'SeCargoDocDestinationPortCode',
  components: { cargoAdvanceSelect },
  props: {
    cargoDoc: { type: Object, default: () => { return {} } }
  },
  data() {
    return {
      TYPE_NAMES
    }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.cargoDoc[key] }])
    }
  }
}
</script>
